import React, { useState, useEffect, useCallback } from 'react';
import { Carousel } from 'react-responsive-carousel';
import PdfViewer from '../../Documents/PDFViewer/PdFViewer';

const isAPdf = (attachment) => {
  let attachmentName = attachment.name;
  // if ends with png,jpg,jpeg,webp is an image
  return attachmentName.endsWith('pdf');
}

const filterAllPdfsAttachments = (attachmentsArr) => {
  // remove all the attachments that aren't images
  return attachmentsArr.filter(isAPdf)
}

const NewsPdfsCarousel = ({ attachments }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [pdfs, setPdfs] = useState([]);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const filteredPdfs = filterAllPdfsAttachments(attachments);
    setPdfs(filteredPdfs);
    return () => {
      setActiveIndex(0);
      setPdfs([]);
      setIsTransitioning(false);
    };
  }, [attachments]);

  const onChange = useCallback((index) => {
    setIsTransitioning(true);
    setActiveIndex(index);
    // Reset transition state after a short delay
    setTimeout(() => {
      setIsTransitioning(false);
    }, 100);
  }, []);

  if (pdfs.length === 0) {
    return null;
  }

  return (
    <>
      <Carousel
        selectedItem={activeIndex}
        onChange={onChange}
        showThumbs={false}
        showStatus={false}
        showArrows={true}
        useKeyboardArrows
        autoPlay={false}
        transitionTime={300}
      >
        {pdfs.map((pdfAttachment, index) => (
          <div 
            key={`pdf-container-${index}-${pdfAttachment.name}`} 
            style={{ 
              textAlign: 'center', 
              width: '70%', 
              margin: 'auto', 
              marginBottom: '7%',
              opacity: isTransitioning && index === activeIndex ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out'
            }}
          >
            <PdfViewer 
              key={`pdf-viewer-${index}-${pdfAttachment.name}`}
              selectedFileContent={{ b64: pdfAttachment.content }} 
            />
          </div>
        ))}
      </Carousel>
    </>
  )
}

export default NewsPdfsCarousel